import React, { type ReactNode } from 'react';
import { Logo } from '../Logo';
import { DeckNav } from './DeckNav';
type SlideFrameProps = {
  children: ReactNode;
  tone?: 'light' | 'dark';
  footerLabel?: string;
};

/**
 * Full-bleed 16:9 slide surface. Acts as a size container so every child can
 * scale with the frame using `cqw` units.
 */
export function SlideFrame({
  children,
  tone = 'light',
  footerLabel = 'Leslie Outreach · Stripe setup guide'
}: SlideFrameProps) {
  const dark = tone === 'dark';
  return <div className={`relative h-full w-full overflow-hidden ${dark ? 'mm-grid-dark bg-mm-charcoal' : 'mm-grid-lg bg-mm-soft-white'}`} style={{
    containerType: 'size'
  }} data-id="element-13" data-mp="2eu41svrmbzpm">
      <div className="absolute inset-x-[6cqw] bottom-[6.2cqw] top-[4cqw] flex flex-col" data-id="element-14" data-mp="24x9249jlzt9r">
        {children}
      </div>
      <footer className="absolute inset-x-[6cqw] bottom-[1.6cqw] flex items-center justify-between" data-id="element-15" data-mp="yh6sdrm6oahr">
        <span className={`flex items-center gap-[0.8cqw] font-body text-[1.05cqw] uppercase tracking-[0.14em] ${dark ? 'text-mm-light-gray' : 'text-mm-mid-gray'}`} data-id="element-16" data-mp="tgj4het949rr">
          <span className="h-[0.6cqw] w-[0.6cqw] bg-mm-orange" aria-hidden="true" data-id="element-17" data-mp="1jjcb6hocjtov" />
          {footerLabel}
        </span>
        <Logo variant="no-tag" mode={dark ? 'dark' : 'light'} className="!h-[4.4cqw] w-auto" data-id="element-18" data-mp="14oo797ylh3bd" />
      </footer>
      <DeckNav tone={tone} data-id="element-19" data-mp="vu017fl73hli" />
    </div>;
}